// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsLinks_DetalheResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /payments/links/detalhe/{id}
 *
 * Returns a single payment link with full details, history, and recebimentos.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type SubaccountsLinks_DetalheResponseDados = unknown[];

export type SubaccountsLinks_DetalheResponse = ApiResponse<SubaccountsLinks_DetalheResponseDados>;

registerResponseContract('SubaccountsLinks_DetalheResponse', {})
